import { PoolCard, PoolCardProps } from '@synergy/components-next';
import { ReactElement, useState } from 'react';
import { UserRole } from '@synergy/models';
import { hasRole } from '@synergy/utils';
import { styled } from '@mui/material';

import { ArticleCardContent } from './article-card-content';
import { ArticleCardHeader } from './article-card-header';
import { useAppSelector } from '../../../../store/store';
import { useArticleCardContext } from '../article-card';
import { userSelector } from '../../../store/configuration-selectors';

const StyledPoolCard = styled(PoolCard)(() => ({
    height: 528,
    width: '100%',
}));

export const ArticleCardPortrait = (props: PoolCardProps): ReactElement => {
    const { href, onOpen } = useArticleCardContext();
    const user = useAppSelector(userSelector);
    const [hover, setHover] = useState(false);

    const canPutInCart = hasRole([UserRole.ShopAdmin, UserRole.ShopUser], user);

    return (
        <StyledPoolCard
            {...props}
            onMouseOver={() => setHover(true)}
            onMouseOut={() => setHover(false)}
            href={href}
            onClick={onOpen}
            data-testid="article-card"
        >
            <ArticleCardHeader />
            <ArticleCardContent showButton={canPutInCart && hover} />
        </StyledPoolCard>
    );
};
